// Catálogo de productos: reemplaza el rol de src/data/stamps.js (que armaba
// el catálogo a partir de archivos locales) por llamadas al backend
// ecommercejwt. La elección proxy/directo y el manejo de status/errores
// viven en ecommerceClient.js (compartido con carrito.js/auth.js/
// direcciones.js).
import { request, buildImageUrl } from './ecommerceClient';

// El selector de cantidad de copias es un dato del negocio, no del catálogo
// -- la API de productos no lo modela, así que se mantiene como una lista
// estática local igual que antes. Se exporta para que el carrito (Carrito.jsx)
// pueda ofrecer las mismas cantidades al editar un item ya agregado.
export const PACK_SIZES = [24, 32, 56, 76, 100];

const baseOptions = PACK_SIZES.map((size) => ({
  type: `${size} copias`,
  price: 0,
  description: "Cantidad de copias seleccionada.",
}));

// Adapta la forma del producto que devuelve la API a la forma que ya
// consume la UI (antes construida en src/data/stamps.js a partir de
// nombres de archivo).
const mapProducto = (producto) => ({
  id: producto.id,
  slug: producto.slug,
  title: producto.nombre,
  description: producto.descripcion,
  category: producto.categoria,
  genre: producto.genero,
  image: buildImageUrl(producto.imagen_url),
  images: (producto.imagenes || []).map(buildImageUrl),
  pricePerUnit: Number(producto.precio),
  stock: producto.stock,
  options: baseOptions,
});

export const getProductos = async ({ categoria } = {}) => {
  const data = await request('/productos', { params: categoria ? { categoria } : undefined });
  // El backend trae, además de las estampitas, algunos productos de
  // ejemplo del template (sin slug ni categoría, ej. "Remera básica") --
  // se descartan porque no tienen una página de producto real.
  return data.filter((producto) => producto.slug && producto.categoria).map(mapProducto);
};

export const getProductoBySlug = async (slug) => {
  const data = await request(`/productos/slug/${encodeURIComponent(slug)}`);
  return mapProducto(data);
};

// "Bautismo" / "Comunion" -> el label legible usado en textos y alt text.
export const categoryLabel = (category) => (category === "Comunion" ? "Primera Comunión" : "Bautismo");

// Alt text descriptivo con keywords para la imagen de un producto en
// `imageIndex` (0 = foto principal). Se usa en el grid del catálogo, la
// previsualización y la galería de /personalizar/:slug.
export const buildStampImageAlt = (stamp, imageIndex = 0) => {
  const base = `Estampita de ${categoryLabel(stamp.category)} "${stamp.title}", hecha a mano en acuarela`;
  return imageIndex === 0 ? base : `${base}, vista ${imageIndex + 1}`;
};
